function t(l, c, e) {
  switch (e.length) {
    case 0:
      return l.call(c);
    case 1:
      return l.call(c, e[0]);
    case 2:
      return l.call(c, e[0], e[1]);
    case 3:
      return l.call(c, e[0], e[1], e[2]);
  }
  return l.apply(c, e);
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_apply.js
// module id = 1414
// module chunks = 41